var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Freewheel = youbora.Adapter.extend({
    /** Override to return current plugin version */
    getVersion: function() {
        return manifest.version + '-' + manifest.name + '-' + manifest.tech
    },

    /** Override to return current playhead of the video */
    getPlayhead: function() {

        if (this.slot) {
            var instances = this.slot.getAdInstances()
            if (instances) {
                var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
                if (instances[adnumber] && instances[adnumber].getPlayheadTime)
                    return instances[adnumber].getPlayheadTime()
            }
        }
        return null
    },

    /** Override to return video duration */
    getDuration: function() {
        if (this.slot) {
            var instances = this.slot.getAdInstances()
            if (instances) {
                var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
                if (instances[adnumber] && instances[adnumber].getDuration)
                    return instances[adnumber].getDuration()
            }
        }
        return null
    },

    /** Override to return title */
    getTitle: function() {
        if (this.titles) {
            return this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._adId
        }
        return "unknown"
    },

    /** Override to return resource URL. */
    getResource: function() {
        if (this.player.originalSource) return this.player.originalSource
        if (this.plugin.getAdapter()) {
            return this.plugin.getAdapter().getResource()
        }
        return null
    },

    /** Override to return player version */
    getPlayerVersion: function() {
        return tv.freewheel.SDK.version
    },

    /** Override to return player's name */
    getPlayerName: function() {
        return "Freewheel"
    },

    getPosition: function() {
        return this.position
    },

    getIsVisible: function() {
        if (!this.contentPlayer) {
            for (key in this.player) {
                var element = this.player[key]
                if (element.videoHeight && element.clientHeight) {
                    this.contentPlayer = element
                    break
                }
            }
        }
        return youbora.Util.calculateAdViewability(this.contentPlayer)
    },

    getIsFullscreen: function() {
        return null //cant get
    },

    getIsSkippable: function() {
        return null //cant get
    },

    getAudioEnabled: function() {
        return this.player.adManager._context.getAdVolume() ? true : false
    },

    getGivenAds: function() {
        return this.slot.getAdCount()
    },

    getBreaksTime: function() {
        var slots = this.player.currentAdContext._adResponse.getTemporalSlots()
        var times = []
        for (slotindex in slots) {
            var slot = slots[slotindex]
            if (slot.getAdCount() > 0) {
                var ads = slot.getAdInstances()
                for (adindex in ads) {
                    if (ads[adindex]._creativeRenditions[0]._baseUnit === "video") {
                        times.push(slot.getTimePosition())
                        break
                    }
                }
            }
        }
        return times
    },

    getExpectedBreaks: function() {
        var slots = this.player.currentAdContext._adResponse.getTemporalSlots()
        var pre = 0
        var mid = 0
        var post = 0
        for (slotindex in slots) {
            var slot = slots[slotindex]
            if (slot.getAdCount() > 0) {
                var containsVideo = false
                var ads = slot.getAdInstances()
                for (adindex in ads) {
                    if (ads[adindex]._creativeRenditions[0]._baseUnit === "video") {
                        containsVideo = true
                        break
                    }
                }
                if (containsVideo) {
                    if (slot.getTimePosition() == 0) {
                        pre++
                    } else if (slot.getTimePosition() > this.plugin.getAdapter().getDuration() - 1) {
                        post++
                    } else {
                        mid++
                    }
                }
            }
        }
        return { pre, mid, post }
    },


    getGivenBreaks: function() {
        var slots = this.player.currentAdContext._adResponse.getTemporalSlots()
        var breaks = 0
        for (slotindex in slots) {
            var slot = slots[slotindex]
            if (slot.getAdCount() > 0) {
                var ads = slot.getAdInstances()
                for (adindex in ads) {
                    if (ads[adindex]._creativeRenditions[0]._baseUnit === "video") {
                        breaks++
                        break
                    }
                }
            }
        }
        return breaks
    },

    /** Register listeners to this.player. */
    registerListeners: function() {
        // Enable playhead monitor
        this.canRemoveListeners = true
            // References
        this.events = tv.freewheel.SDK
        this.manifestNoResponse = [
            this.events.ERROR_SECURITY,
            this.events.ERROR_TIMEOUT
        ]
        this.manifestEmpty = [
            this.events.ERROR_NO_AD_AVAILABLE,
            this.events.ERROR_VAST_NO_AD
        ]
        this.manifestWrong = [
            this.events.ERROR_VAST_VERSION_NOT_SUPPORTED,
            this.events.ERROR_VAST_WRAPPER_LIMIT_REACH,
            this.events.ERROR_VAST_XML_PARSING,
            this.events.ERROR_PARSE
        ]
        this.ignoredErrors = [
            this.events.ERROR_ADINSTANCE_UNAVAILABLE
        ]
        this.references = []
        this.references[this.events.EVENT_AD] = this.logListener.bind(this)
        this.references[this.events.EVENT_ERROR] = this.errorListener.bind(this)
        this.references[this.events.EVENT_REQUEST_COMPLETE] = this.readyListener.bind(this)
        this.references[this.events.EVENT_SLOT_STARTED] = this.slotListener.bind(this)
        this.references[this.events.EVENT_SLOT_ENDED] = this.closeListener.bind(this)
        for (var key in this.manifestNoResponse) {
            this.references[key] = this.noResponseManifestListener.bind(this)
        }
        for (var key in this.manifestEmpty) {
            this.references[key] = this.manifestEmptyListener.bind(this)
        }
        for (var key in this.manifestWrong) {
            this.references[key] = this.manifestWrongListener.bind(this)
        }

        for (var key in this.references) {
            this.player.currentAdContext.addEventListener(key, this.references[key])
        }
    },

    /** Unregister listeners to this.player. */
    unregisterListeners: function() {
        // unregister listeners
        if (this.player && this.references) {
            for (var key in this.references) {
                this.player.currentAdContext.removeEventListener(key, this.references[key])
            }
            this.references = []
        }
    },

    readyListener: function(e) {
        this.ready = true
    },

    noResponseManifestListener: function(e) {
        this.fireManifest(youbora.Adapter.ManifestError.NO_RESPONSE, "No response")
    },

    manifestEmptyListener: function(e) {
        this.fireManifest(youbora.Adapter.ManifestError.EMPTY, "Empty manifest")
    },

    manifestWrongListener: function(e) {
        this.fireManifest(youbora.Adapter.ManifestError.WRONG, "Wrong manifest format")
    },

    logListener: function(e) {
        youbora.Log.debug(e.subType)
        if (!this.ready) return
        if (e.errorCode || e.errorInfo || e.errorModule) {
            this.errorListener(e)
            return
        }
        switch (e.subType) {
            case this.events.EVENT_AD_PAUSE:
                this.pauseListener(e)
                break
            case this.events.EVENT_AD_RESUME:
                this.resumeListener(e)
                break
            case this.events.EVENT_AD_IMPRESSION_END:
                this.endedListener(e)
                break
            case this.events.EVENT_AD_INITIATED:
                this.playListener(e)
                break
            case this.events.EVENT_AD_IMPRESSION:
                this.playingListener(e)
                break
            case this.events.EVENT_AD_SKIPPED:
                this.skipListener(e)
                break
            case this.events.EVENT_SLOT_STARTED:
                this.slotListener(e)
                break
            case this.events.EVENT_AD_CLOSE:
            case this.events.EVENT_SLOT_ENDED:
                this.closeListener(e)
                break
            case this.events.EVENT_AD_CLICK:
                this.clickListener(e)
                break
            case this.events.EVENT_AD_FIRST_QUARTILE:
                this.fireQuartile(1)
                break
            case this.events.EVENT_AD_MIDPOINT:
                this.fireQuartile(2)
                break
            case this.events.EVENT_AD_THIRD_QUARTILE:
                this.fireQuartile(3)
                break
        }
    },

    slotListener: function(e) {
        if (!this.ready) return
        this.slot = e.slot
        var position = e.slot.getTimePositionClass()
        this.disable = false
        if (position === "POSTROLL") {
            this.position = youbora.Adapter.AdPosition.POSTROLL
        } else if (position === "MIDROLL") {
            this.position = youbora.Adapter.AdPosition.MIDROLL
        } else if (position === "PREROLL") {
            this.position = youbora.Adapter.AdPosition.PREROLL
            if (this.plugin.getAdapter() && this.plugin.getAdapter().flags.isJoined) {
                this.position = youbora.Adapter.AdPosition.MIDROLL
            }
        } else {
            this.disable = true
        }
        if (!this.disable) {
            this.titles = e.slot.getAdInstances()
            if (this.plugin.getAdapter() && this.canRemoveListeners) {
                this.canRemoveListeners = false
                this.plugin.getAdapter().unregisterListeners()
                this.plugin.getAdapter().firePause()
            }
            this.plugin.fireInit()
            this.fireInit()
        }
    },
    playListener: function(e) {
        if (!this.ready || this.disable) return
        this.fireStart()
    },
    playingListener: function(e) {
        if (!this.ready || this.disable) return
        this.fireStart()
        this.fireJoin()
    },
    pauseListener: function(e) {
        this.firePause()
    },
    resumeListener: function(e) {
        this.playListener()
        this.fireResume()
    },
    endedListener: function(e) {
        this.fireStop()
    },
    skipListener: function(e) {
        this.fireSkip()
    },
    clickListener: function(e) {
        var url = e.adInstance.getEventCallbackUrls(tv.freewheel.SDK.EVENT_AD_CLICK, tv.freewheel.SDK.EVENT_TYPE_CLICK)[0]
        this.fireClick(url)
    },
    closeListener: function(e) {
        this.register()
        if (this.position === youbora.Adapter.AdPosition.POSTROLL && !this.disable) {
            this.plugin.fireStop()
        }
    },
    errorListener: function(e) {
        this.fireError(e.errorCode || e.subType, e.errorInfo)
        this.fireStop()
        this.register()
    },

    register: function(e) {
        if (this.plugin.getAdapter() && !this.canRemoveListeners) {
            this.plugin.getAdapter().registerListeners()
            this.plugin.getAdapter().fireResume()
            this.canRemoveListeners = true
        }
    },

    changeVideo: function(e) {
        if (this.flags.isStarted || this.flags.isInited) {
            this.fireStop()
            this.plugin.fireStop()
            this.register()
        }
    }
})

module.exports = youbora.adapters.Freewheel